import React, { useState, useEffect } from 'react';
import {
	Card,
	Col,
	Container,
	Input,
	InputGroup,
	Label,
	Row,
	InputGroupText,
	Button,
	CardHeader,
	Badge,
} from 'reactstrap';
import { toast } from 'react-toastify';
import { useHistory, useLocation } from 'react-router-dom';
import Products from '../assets/data/Products.json';
import Categories from '../assets/data/Category.json';
import Banner from '../assets/img/banner-delivery-2.jpg';
import BannerSidebar from '../assets/img/banner-sidebar.jpg';
import Header from '../components/Header';
import MenuHeader from '../components/MenuHeader';
import Footer from '../components/Footer';
import { useSelector, useDispatch } from 'react-redux';
import { getProducts } from '../Redux/actions/productActions';
import { getCategories } from '../Redux/actions/categoryActions';

const Shop = () => {
	const location = useLocation();
	const query = location.search.split('?')[1];
	const [current, setCurrent] = useState('Sleeping Pill');
	const [currentCart, setCurrentCart] = useState([]);
	const [valueCart, setValueCart] = useState({ id: '', value: 1 });
	const history = useHistory();
	const dispatch = useDispatch();
	const { allProducts } = useSelector(state => state.products);
	const { allCategories } = useSelector(state => state.category);
	const getAllProduct = () => {
		dispatch(getProducts());
	};
	const getAllCategories = () => {
		dispatch(getCategories());
	};
	useEffect(() => {
		if (query) {
			setCurrent(query);
		}
		if (!allProducts.length) {
			getAllProduct();
		}
		if (!allCategories.length) {
			getAllCategories();
		}
	}, [query]);
	return (
		<>
			<Header />
			<MenuHeader />
			<Container className='mt-2'>
				<Row>
					<Col md={3}>
						<div>
							<span className='theme__color'>Categories</span>
						</div>
						<div className='theme__color__only pt-2'>
							Click Below to Filter
						</div>
						{allCategories.map(category => (
							<div className=' pt-2 category__class'>
								<span
									onClick={() =>
										setCurrent(category.categoryName)
									}
								>
									{category.categoryName}
								</span>
							</div>
						))}

						<div className='mt-5'>
							<img
								className='img-fluid'
								src={BannerSidebar}
								alt='bannersidebar'
							/>
						</div>
					</Col>
					<Col md={9}>
						<Row className='color__class m-1'>
							<Col md={1}>
								<i className='fas fa-bars fa-2x' />
							</Col>
							<Col md={4} className='font-weight-bold'>
								<Input type='checkbox' />
								Show only Product on sale
							</Col>
							<Col md={3}>
								<span>Items per page</span>
								<div>
									<Input
										className='color__class__simple'
										type='select'
									>
										<option>5</option>
										<option>10</option>
										<option>15</option>
									</Input>
								</div>
							</Col>
							<Col md={2}>
								<span className='mx-auto'>Sort by</span>
								<div>
									<Input
										className='color__class__simple'
										type='select'
									>
										<option>Latest</option>
										<option>Popularity</option>
										<option>Average Rating</option>
									</Input>
								</div>
							</Col>
							<Col md={2} align='center'>
								<span className='mx-auto'>Show</span>
								<div>
									<Input
										className='w-50 color__class__simple'
										type='select'
									>
										<option>12</option>
										<option>24</option>
										<option>36</option>
									</Input>
								</div>
							</Col>
						</Row>
						{allProducts.filter(pt => pt.category == current)
							.length == 0 ? (
							<Card className='card__danger  mt-5'>
								Currently, No Product Available in this Category
							</Card>
						) : (
							allProducts
								.filter(pt => pt.category == current)
								.map(singleCard => (
									<Card className='card__class my-2'>
										<Row>
											<Col md={3}>
												<img
													width='150'
													src={singleCard.imageURLID}
													alt='cardImage'
												/>
											</Col>
											<Col md={6}>
												<div className='tablet__composition'>
													{singleCard.composition}
												</div>
												<div className='tablet__composition1 font-weight-bold'>
													{singleCard.name}
												</div>
												<Input
													type='select'
													onChange={e => {
														if (
															currentCart.find(
																c =>
																	c.id ==
																	singleCard.id
															)
														) {
															let duplicateCart =
																currentCart;
															let indexOfCard =
																currentCart.findIndex(
																	x =>
																		x.id ==
																		singleCard.id
																);
															duplicateCart[
																indexOfCard
															] = {
																...singleCard,
																price: e.target
																	.value,
															};
															setCurrentCart(
																duplicateCart
															);
														} else {
															setCurrentCart([
																...currentCart,
																{
																	...singleCard,
																	price: e
																		.target
																		.value,
																},
															]);
														}
													}}
												>
													{singleCard.typesOfPill.map(
														(pilt, index) => (
															<option
																value={
																	pilt.our_price
																}
															>
																{pilt.quantity}{' '}
																pills for{' '}
																{pilt.our_price}
															</option>
														)
													)}
												</Input>
												<div>
													{singleCard.tags.map(tg => (
														<Badge
															className='ml-1'
															color='success'
														>
															{tg}
														</Badge>
													))}
												</div>
												<div
													dangerouslySetInnerHTML={{
														__html: singleCard.description,
													}}
												></div>
												{/* <div>
													{' '}
													<i className='fas fa-check mr-1' />
													Study history up to 30 days
												</div>
												<div className='pt--1'>
													{' '}
													<i className='fa-solid fa-check mr-1' />
													Up to 5 users simultaneously
												</div>
												<div>
													{' '}
													<i className='fa-solid fa-check mr-1' />
													Has HEALTH certificate
												</div> */}
											</Col>
											<Col md={3}>
												<div className='m-1'>
													<span className='font-weight-bold theme__color'>
														$
														{currentCart.length
															? currentCart.find(
																	c =>
																		c.id ==
																		singleCard.id
															  ) !== undefined
																? currentCart.find(
																		c =>
																			c.id ==
																			singleCard.id
																  ).price
																: singleCard
																		.typesOfPill[0]
																		.our_price
															: singleCard
																	.typesOfPill[0]
																	.our_price}
													</span>
													<span>
														<del>
															$
															{Number(
																Number(
																	singleCard
																		.typesOfPill[0]
																		.our_price
																) + 8
															).toFixed(2)}
														</del>{' '}
														for pills
													</span>
													<Label>Quantity</Label>
													<InputGroup className='rounded'>
														<InputGroupText
															style={{
																backgroundColor:
																	'#F0F2F5',
															}}
															onClick={() => {
																valueCart &&
																valueCart.id ==
																	singleCard.id
																	? setValueCart(
																			{
																				...valueCart,
																				value:
																					valueCart.value +
																					1,
																			}
																	  )
																	: setValueCart(
																			{
																				id: singleCard.id,
																				value: 1,
																			}
																	  );
															}}
															className='border-0'
														>
															<i className='fas fa-plus' />
														</InputGroupText>
														<Input
															style={{
																backgroundColor:
																	'#F0F2F5',
															}}
															className=' border-0'
															value={
																valueCart &&
																valueCart.id ==
																	singleCard.id
																	? valueCart.value
																	: 1
															}
															onChange={e => {
																setValueCart({
																	id: singleCard.id,
																	value: e
																		.target
																		.value,
																});
															}}
														/>
														<InputGroupText
															style={{
																backgroundColor:
																	'#F0F2F5',
															}}
															className='border-0'
															onClick={() => {
																valueCart &&
																valueCart.id ==
																	singleCard.id
																	? valueCart.value <
																	  2
																		? setValueCart(
																				valueCart
																		  )
																		: setValueCart(
																				{
																					...valueCart,
																					value:
																						valueCart.value -
																						1,
																				}
																		  )
																	: setValueCart(
																			{
																				id: singleCard.id,
																				value: 1,
																			}
																	  );
															}}
														>
															<i className='fas fa-minus' />
														</InputGroupText>
													</InputGroup>
													<Button
														onClick={() => {
															let duplicate;
															let ourItem =
																currentCart.find(
																	cc =>
																		cc.id ==
																		singleCard.id
																);
															if (ourItem) {
																duplicate =
																	ourItem;
																duplicate[
																	'value'
																] =
																	valueCart.id ==
																	ourItem.id
																		? valueCart.value
																		: 1;
															} else {
																duplicate =
																	singleCard;
																duplicate.price =
																	singleCard.typesOfPill[0].our_price;
																duplicate.value = 1;
															}
															let items =
																JSON.parse(
																	localStorage.getItem(
																		'cart'
																	)
																);
															if (items) {
																let newItems = [
																	...items,
																	duplicate,
																];
																localStorage.setItem(
																	'cart',
																	JSON.stringify(
																		newItems
																	)
																);
																toast.success(
																	'Added To Cart'
																);
																history.push(
																	'/shoppingCart'
																);
															} else {
																let newItems = [
																	duplicate,
																];
																localStorage.setItem(
																	'cart',
																	JSON.stringify(
																		newItems
																	)
																);
																toast.success(
																	'Added To Cart'
																);
																history.push(
																	'/shoppingCart'
																);
															}
														}}
														className=' w-100 cart__button'
													>
														Add to Cart
													</Button>
												</div>
											</Col>
										</Row>
									</Card>
								))
						)}

						<Row className='my-4'>
							<Col md={4}>
								<Button className='border mr-2' color='light'>
									<i className='fa-solid fa-angles-left' />
								</Button>
								<Button className='border' color='light'>
									<i className='fa-solid fa-angles-right' />
								</Button>
							</Col>
						</Row>
						<Row>
							<div class='container__class'>
								<img
									className='img-fluid'
									src={Banner}
									alt='banner'
								/>
								<div className='center__left'>
									<i className='fa-solid fa-shield mr-1' />
									<strong>100 % Secure Delivery</strong>{' '}
									without contacting the courier
								</div>
								{/* <Button className='center__right'>More</Button> */}
							</div>
						</Row>
					</Col>
				</Row>
				{/* <Card className='last__row my-2'>
					<Row className='my-3'>
						<Col md={4} align='center'>
							<span className='font-weight-bold'>
								100 % Money Back
							</span>
						</Col>
						<Col md={4} align='center'>
							<span className='font-weight-bold'>
								Non Contact Shipping
							</span>
						</Col>
						<Col md={4} align='center'>
							<span className='font-weight-bold'>
								Free Delivery for Order over $200
							</span>
						</Col>
					</Row>
				</Card> */}
			</Container>
			<Footer />
		</>
	);
};

export default Shop;
